import { render, staticRenderFns } from "./ModalMigrateAgreement.vue?vue&type=template&id=28e5e582&"
import script from "./ModalMigrateAgreement.vue?vue&type=script&lang=js&"
export * from "./ModalMigrateAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports